import {Component} from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import {MarketGroup} from '../../shared/models/markets-config.model';
import {parseRangesCsv, parseServicesCsv} from '../shared/markets-csv.util';

// Shared by both Markets modes (parameterised by `mode`, same pattern SaveChangesDialogComponent
// already uses) rather than two near-identical dialogs - the popup chrome (warning, paste/file
// input, error list, footer) is identical, only which parser runs on Import differs.
@Component({
    selector: 'app-import-markets-dialog',
    templateUrl: './import-markets-dialog.component.html',
    styleUrls: ['./import-markets-dialog.component.scss']
})
export class ImportMarketsDialogComponent {
    // Set by the caller right after dialogService.open(), before the dialog is shown.
    mode: 'ranges' | 'services' = 'ranges';

    csvText = '';
    errors: string[] = [];
    fileName = '';

    constructor(private dialogRef: DialogRef) {
    }

    public onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) {
            return;
        }
        this.fileName = file.name;
        const reader = new FileReader();
        // One source of truth for the CSV text either way it arrived - a chosen file just
        // populates the same textarea a paste would, so onImport() never has to know which.
        reader.onload = () => {
            this.csvText = String(reader.result ?? '');
        };
        reader.readAsText(file);
    }

    public onCancel(): void {
        this.dialogRef.close({confirmed: false});
    }

    public onImport(): void {
        const parser = this.mode === 'services' ? parseServicesCsv : parseRangesCsv;
        const {groups, errors} = parser(this.csvText);
        if (errors.length) {
            this.errors = errors;
            return;
        }
        this.dialogRef.close({confirmed: true, groups} as {confirmed: true; groups: MarketGroup[]});
    }
}
